function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import { parseQueryStringParams } from '../../utils/query-string';
export var BetterComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(BetterComponent, _React$Component);

  var _super = _createSuper(BetterComponent);

  function BetterComponent() {
    var _this;

    _classCallCheck(this, BetterComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.unmounting = false;
    return _this;
  }

  _createClass(BetterComponent, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounting = true;
    }
  }, {
    key: "injectedProps",
    get: function get() {
      return this.props;
    }
  }, {
    key: "queryString",
    get: function get() {
      try {
        return parseQueryStringParams(this.injectedProps.location.search);
      } catch (_unused) {
        return parseQueryStringParams();
      }
    }
  }, {
    key: "router",
    get: function get() {
      return this.context.router;
    }
  }, {
    key: "matchedPath",
    get: function get() {
      return this.injectedProps.match.path;
    }
  }, {
    key: "globalDomain",
    get: function get() {
      var domain;

      if ('appState' in this) {
        domain = this.appState.currentDomain;
      }

      return domain;
    }
  }, {
    key: "localDomain",
    get: function get() {
      var domain;

      if ('domain' in this.state) {
        domain = this.state.domain;
      }

      return domain;
    }
  }, {
    key: "setState",
    value: function setState(stateUpdater, callback) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        if (!_this2.unmounting) {
          _get(_getPrototypeOf(BetterComponent.prototype), "setState", _this2).call(_this2, stateUpdater, resolve);
        } else {
          resolve();
        }
      });
    }
  }]);

  return BetterComponent;
}(React.Component); // tslint:disable-next-line:max-classes-per-file

export var BetterFormComponent = /*#__PURE__*/function (_BetterComponent) {
  _inherits(BetterFormComponent, _BetterComponent);

  var _super2 = _createSuper(BetterFormComponent);

  function BetterFormComponent() {
    _classCallCheck(this, BetterFormComponent);

    return _super2.apply(this, arguments);
  }

  _createClass(BetterFormComponent, [{
    key: "setFieldsAndState",
    value: function () {
      var _setFieldsAndState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setState(function () {
                  return Object.assign({}, _this3.state, values);
                });

              case 2:
                this.setFieldsValues(values);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setFieldsAndState(_x) {
        return _setFieldsAndState.apply(this, arguments);
      }

      return setFieldsAndState;
    }()
  }, {
    key: "getFieldDecorator",
    value: function getFieldDecorator(id, options) {
      return this.props.form.getFieldDecorator(id, options);
    }
  }, {
    key: "getFieldValue",
    value: function getFieldValue(fieldName) {
      return this.props.form.getFieldValue(fieldName);
    }
  }, {
    key: "validateFields",
    value: function validateFields() {
      var _this4 = this;

      var excludeFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var fieldNames = Object.keys(this.props.form.getFieldsValue()).filter(function (f) {
        return excludeFields.indexOf(f) === -1;
      });
      return new Promise(function (resolve, reject) {
        _this4.props.form.validateFields(fieldNames, {
          force: true
        }, function (errors, values) {
          if (errors) {
            reject(errors);
          } else {
            resolve(values);
          }
        });
      });
    }
  }, {
    key: "passiveValidateFields",
    value: function passiveValidateFields() {
      var _this5 = this;

      return new Promise(function (resolve) {
        _this5.props.form.validateFields(function (errors, values) {
          resolve(values);
        });
      });
    }
  }, {
    key: "setFieldsValues",
    value: function setFieldsValues(fields) {
      this.props.form.setFieldsValue(fields);
      this.props.form.validateFields();
    }
  }]);

  return BetterFormComponent;
}(BetterComponent);